var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeokaslogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350,
    height: 51.929,
    viewBox: "0 0 350 51.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15599f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#36b6aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4a501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00afa8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.001,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15599f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#36b6aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#00b0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.343,
    y1: 0.053,
    x2: 0.758,
    y2: 1.006,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fab720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07e25"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9617",
    "data-name": "Group 9617",
    transform: "translate(-220 -277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M4.676,0A3.364,3.364,0,0,1,5.943.292,4.519,4.519,0,0,1,9.158,4.676c-.1.1-.1.39-.195.974-.779,2.241-2.241,3.41-4.287,3.41H3.9C1.267,8.281,0,6.722,0,4.579A3.364,3.364,0,0,1,.292,3.313,4.342,4.342,0,0,1,4.676,0m53.2,0a4.888,4.888,0,0,1,1.364.292c2.143.974,3.215,2.436,3.215,4.287l-.1.39C61.769,7.21,57.482,20.947,49.59,46.278c-.779,3.8-2.436,5.651-5.066,5.651a4.882,4.882,0,0,1-3.9-2.143c-.487-1.169-3.6-11.107-9.353-29.715h-.195C25.818,36.925,23.09,45.5,22.993,45.791c-.877,4.092-2.533,6.04-5.066,6.04A4.649,4.649,0,0,1,13.737,49.3c-4.871-15.881-7.4-24.162-7.4-24.649a5.936,5.936,0,0,1,.39-1.656c1.072-1.949,2.436-2.923,4.287-2.923a4.855,4.855,0,0,1,3.8,2.143c.39.877,1.461,4.092,3.118,9.645h.1c.1-.195,3.118-9.645,8.866-28.156C27.572,1.169,29.033,0,31.079,0a4.613,4.613,0,0,1,4.092,2.533l3.02,9.353c3.995,13.055,6.04,19.68,6.235,19.875h.1L53.39,3.507C54.267,1.169,55.826,0,57.872,0Z",
    transform: "translate(220 277)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M102.5,42.576a6.629,6.629,0,0,1,1.461.195c2.338.877,3.507,2.338,3.507,4.287a5.591,5.591,0,0,1-.1,1.169,4.936,4.936,0,0,1-5.066,3.7H77.366a5.088,5.088,0,0,1-2.046-.39,4.6,4.6,0,0,1-3.02-4.287,4.014,4.014,0,0,0,.195-.877,4.653,4.653,0,0,1,4.871-3.7H102.5ZM77.074,21.337a3.364,3.364,0,0,1,1.267.292c2.143.974,3.215,2.338,3.215,4.189a10.233,10.233,0,0,1-.195,1.267c-.877,2.338-2.338,3.507-4.287,3.507h-.195a8.1,8.1,0,0,1-1.267-.195c-2.241-.974-3.313-2.436-3.313-4.482l.195-.974c.877-2.338,2.338-3.6,4.482-3.6h.1Zm25.818,0a3.655,3.655,0,0,1,.974.1c2.436.877,3.6,2.338,3.6,4.384v.195a3.364,3.364,0,0,1-.292,1.267,4.519,4.519,0,0,1-4.384,3.215H89.934a3.655,3.655,0,0,1-.974-.1c-2.436-.877-3.6-2.338-3.6-4.384v-.292a3,3,0,0,1,.292-1.267,4.429,4.429,0,0,1,4.384-3.118ZM102.4,0a9.715,9.715,0,0,1,1.559.195q3.507,1.315,3.507,4.384a6.9,6.9,0,0,1-.1,1.364,4.909,4.909,0,0,1-4.871,3.41H77.366a8.689,8.689,0,0,1-2.143-.292C73.274,7.989,72.3,6.528,72.3,4.774l.39-1.559A4.625,4.625,0,0,1,77.366,0Z",
    transform: "translate(220.77 277)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6958",
    "data-name": "Path 6958",
    d: "M133.123,22.537A4.223,4.223,0,1,1,128.9,26.76,4.086,4.086,0,0,1,133.123,22.537Z",
    transform: "translate(209.961 297.708)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6956",
    "data-name": "Path 6956",
    d: "M349.159,32.168a11.142,11.142,0,0,1,.832,4.216,14.616,14.616,0,0,1-6.323,12.259c-8.209,5.27-18.97,4.216-25.127-3.384a15.325,15.325,0,0,1-2.94-8.653,4.363,4.363,0,0,1,4.216-4.216c7.155,0,.832,11.371,12.869,11.371,5.713,0,10.151-3.772,7.155-9.929a4.415,4.415,0,0,1-.61-2.108c0-1.886,1.054-3.162,3.162-3.994,3.217-1.22,5.547,2.108,6.767,4.437M316.488,19.743a11.141,11.141,0,0,1-.832-4.216,14.616,14.616,0,0,1,6.323-12.259c8.209-5.27,18.97-4.216,25.127,3.384a15.457,15.457,0,0,1,2.94,8.875,4.363,4.363,0,0,1-4.216,4.216c-7.155,0-.832-11.371-12.869-11.371-5.713,0-10.151,3.772-7.155,9.929a4.416,4.416,0,0,1,.61,2.108c0,1.886-1.054,3.162-3.162,3.994C320.038,25.456,317.541,21.851,316.488,19.743Zm16.252,1.5a4.659,4.659,0,1,1-4.659,4.659A4.839,4.839,0,0,1,332.74,21.241Z",
    transform: "translate(219.954 277.009)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6957",
    "data-name": "Path 6957",
    d: "M208.84,51.683a4.027,4.027,0,0,0,2.34.446,5.453,5.453,0,0,0,2.73-1.5c.223-.223.223-.446.446-.613L232.576,13.8,242.1,32.4a3.943,3.943,0,0,0,3.789,2.34,4.125,4.125,0,0,0,3.622-2.117,3.972,3.972,0,0,0,0-4.012L236.587,2.763A4.388,4.388,0,0,0,232.8.2a4.322,4.322,0,0,0-3.789,2.563L206.946,46a4.7,4.7,0,0,0-.446,2.34,4.374,4.374,0,0,0,2.34,3.343m45.521-8.246a4.235,4.235,0,1,1-4.235,4.235A4.034,4.034,0,0,1,254.361,43.437Z",
    transform: "translate(264.091 276.8)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    d: "M133.123.178A4.221,4.221,0,0,1,137.346,4.4v8.891a4.223,4.223,0,1,1-8.446,0V4.179a4.181,4.181,0,0,1,4.223-4m0,34.453a4.221,4.221,0,0,1,4.223,4.223v8.891a4.223,4.223,0,1,1-8.446,0V38.853A4.221,4.221,0,0,1,133.123,34.63Zm0-12.67a4.223,4.223,0,1,1-4.223,4.223A4.086,4.086,0,0,1,133.123,21.961Zm9.724-1.278a4.159,4.159,0,0,0,5.946,0L162.3,7.346a4.159,4.159,0,0,0,0-5.946,4.159,4.159,0,0,0-5.946,0l-13.5,13.336A4.065,4.065,0,0,0,142.848,20.683Zm0,10.78a4.159,4.159,0,0,1,5.946,0L162.3,44.8a4.2,4.2,0,0,1-5.946,5.946l-13.5-13.336A4.066,4.066,0,0,1,142.848,31.463Z",
    transform: "translate(294.012 276.85)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9616",
    "data-name": "Group 9616",
    transform: "translate(358.346 277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    d: "M38.281,0A25.968,25.968,0,0,1,64.287,26.006v1.667a4.706,4.706,0,0,1-4,2.556,4.6,4.6,0,0,1-4.223-2.945V26.006a17.56,17.56,0,1,0-35.119,0A17.041,17.041,0,0,0,25.389,37.62,4.9,4.9,0,0,1,23.5,42.9a4.812,4.812,0,0,1-4.445.222A26.2,26.2,0,0,1,12.5,26.006,25.641,25.641,0,0,1,38.281,0",
    transform: "translate(-12.494 0)",
    fill: "#f07e25",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7054",
    "data-name": "Path 7054",
    d: "M38.506,58.59A25.968,25.968,0,0,1,12.5,32.584V30.917a5.059,5.059,0,0,1,4.223-2.334,4.6,4.6,0,0,1,4.223,2.945v1.278a17.56,17.56,0,1,0,35.119,0A17.041,17.041,0,0,0,51.62,21.192a4.374,4.374,0,0,1,1.889-5.279,3.934,3.934,0,0,1,4.223-.445A25.9,25.9,0,0,1,38.506,58.59",
    transform: "translate(-12.497 -6.689)",
    fill: "url(#linear-gradient-7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeokaslogin);
export default __webpack_public_path__ + "static/media/weokaslogin.71aded81643aa7ce4d09f6cea0d1d485.svg";
export { ForwardRef as ReactComponent };